import { Component, ElementRef, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { BaseService } from '@app/services';
import { DirectivesModule, SharedModule } from '@app/shared';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { AuthService, IForgot } from '../auth.service';
import { AuthShellComponent } from '../shell';
import { ForgotFormInterface, ForgotFormValuesInterface } from './forgot.interface';

/**
 * Sends a password-reset email from the dedicated /forgot route.
 */
@Component({
  imports: [SharedModule, DirectivesModule, AuthShellComponent],
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
})
export class ForgotComponent extends BaseService implements OnInit {
  private readonly el = inject(ElementRef);
  private readonly authService = inject(AuthService);

  formForgot: FormGroup;

  ngOnInit(): void {
    this.createForm();
  }

  createForm(): void {
    this.formForgot = new FormGroup<ForgotFormInterface>({
      email: new FormControl('', [RxwebValidators.required(), RxwebValidators.email()]),
    });
  }

  async sendResetLink(): Promise<void> {
    const formValues: ForgotFormValuesInterface = this.formForgot.getRawValue();
    const { email } = formValues;
    this._spin.start();
    const params: IForgot = {
      email: email,
    };
    await this.authService
      .forgot(params)
      .then(() => {
        this._toast.success({ message: 'E-mail enviado com sucesso! Verifique sua caixa de entrada' });
        const message: string =
          'Enviamos um e-mail para o endereço informado contendo mais instruções para redefinir sua senha.</br></br>Se você não receber o email dentro de alguns minutos, verifique a caixa de spam ou lixo eletrônico de seu email.</br></br>Se precisar de ajuda</br>contate nossa central de suporte.';
        void this._alert.message(message);
      })
      .catch(() => {
        this._toast.error({ message: 'Não foi possível enviar o e-mail, verifique os dados informados' });
      })
      .finally(() => {
        this._spin.stop();
        this.setFocus('email');
      });
  }

  setFocus(value: string): void {
    this.el.nativeElement.querySelector(`#${value}`).focus();
  }
}
